<template>
  <div class="container">
    <vue-horizontal-list :items="items" :options="options">
      <template v-slot:default="{ item }">
        <div>
          <div class="image-container">
            <img class="img-fluid" v-bind:src="item.image" />
          </div>
        </div>
      </template>
    </vue-horizontal-list>
  </div>
</template>

<script>
import VueHorizontalList from "vue-horizontal-list";
export default {
   name: 'SliderImages',
  components: {
    VueHorizontalList,
  },
  data() {
    return {
      items: [
        {
          image: require('../assets/office_1.jpeg')
        },
        {
          image: require('../assets/office_2.jpeg')
        },
        {
          image: require('../assets/office_3.jpeg')
        },
        {
          image: require('../assets/office_4.jpeg')
        }
      ],
      options: { },
    };
  },
};
</script>

<style lang="scss" scoped>
.image-container {
  border-radius: 3px;
  overflow: hidden;
  position: relative;
  width: 100%;
  padding-top: 120%;

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
}

@media only screen and (max-width: 625px) {
  .image-container { 
    img { 
      height: 50vh;
    }
  }
}
</style>